import { FF2Step, FormData } from "../types";

export const handleSignupStep = (formData: FormData) => {
  let nextStep = FF2Step.Signup;

  if (formData.magicLinkSent) {
    nextStep = FF2Step.MagicLinkSent;
  }

  return nextStep;
};
